// extracted by mini-css-extract-plugin
export default {"Logo":"LogoLeft_Logo__Wv1O5","Toggle":"LogoLeft_Toggle__t7AE7"};